import React from 'react'

import * as S from './radio.styled'

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked?: boolean
  label?: string
}

export const Radio = ({
  checked = false,
  label,
  disabled = false,
  onChange,
  ...props
}: RadioProps) => {
  return (
    <S.RadioLabel $disabled={disabled}>
      <S.RadioInput
        type="radio"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        {...props}
      />
      <S.RadioBox $checked={checked} $disabled={disabled}>
        {checked && <S.RadioIndicator $disabled={disabled} />}
      </S.RadioBox>
      {label && <S.RadioLabelText $disabled={disabled}>{label}</S.RadioLabelText>}
    </S.RadioLabel>
  )
}
